import { useState, type FormEvent } from "react";

const SUBSCRIBE_URL = "https://readdy.ai/api/form/daihmnjp14a1h3mr74f0";

interface FormResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const guard = String(formData.get("website_alt") ?? "").trim();
    if (guard) {
      setStatus("success");
      setFormError("");
      return;
    }

    const email = String(formData.get("email") ?? "").trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setFormError("请输入有效的邮箱地址");
      return;
    }

    setStatus("submitting");
    setFormError("");

    try {
      const response = await fetch(SUBSCRIBE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (!response.ok || parsed?.code !== "OK" || isSpam || !serverMsg) {
        setStatus("error");
        setFormError(
          isSpam || !response.ok
            ? "提交未成功，请稍后重试"
            : String(serverMsg) || "提交未成功，请稍后重试",
        );
        return;
      }

      setStatus("success");
      setFormError("");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试");
    }
  };

  return (
    <div>
      <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-2 sm:flex-row">
        <input
          type="email"
          name="email"
          required
          placeholder="your@email.com"
          aria-label="订阅邮箱"
          className="w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
        />
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="form-field-guard"
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === "submitting" ? "提交中…" : "订阅更新"}
        </button>
      </form>
      {status === "success" && (
        <p className="mt-2 flex items-center gap-1.5 text-xs text-primary-700">
          <i className="ri-checkbox-circle-line"></i> 订阅成功，每周更新会发送到你的邮箱
        </p>
      )}
      {status === "error" && (
        <p className="mt-2 flex items-center gap-1.5 text-xs text-accent-700">
          <i className="ri-error-warning-line"></i> {formError}
        </p>
      )}
    </div>
  );
}